

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import { AxiosResponse } from "axios";
import GoogleMap from "@/scripts/mapping/map";

import { PrefTypesEnum, PrefTypeRequest, Pref } from "@/store/settings/types";
import { RaiseDuressEvent, RaiseDuressEventResponse } from "@/store/mobile/types";
import api from "@/services/api.mobile.service";
import DuressModal from "@/components/mobile/core/DuressModal.vue";
import ConfirmationModal from "@/components-shared/ConfirmationModal.vue"

const SettingsStore = namespace("settings");
const Mobile = namespace("mobile");

@Component({
	components: {
	    "duress-modal": DuressModal,
        "confirmation-modal": ConfirmationModal
	}
})
export default class DispatchMobile extends Vue {

    @SettingsStore.Action loadAllPrefs: () => Promise<void>;
    @SettingsStore.Getter getPref: (prefType: PrefTypeRequest) => Pref;
    @Mobile.State(state => state.DeviceLocation) deviceLocation: google.maps.LatLng;

    private modalTimeoutPeriodInSeconds: number = 5;
    private dataLoaded: boolean = false;

    private readonly raiseEventSuccessfulStatusNumber: number = 200;

    private showDuressModal: boolean = false;
    private duressModalMessage: string = null;

    private showErrorModal: boolean = false;
    private errorModalMessage: string = null;

    private raiseDuressEventTime: number = 5000;
	private raiseDuressEventTimeOut: NodeJS.Timeout = null;

    private raiseDuressEventDisplayTime: number = 1000;
	private raiseDuressEventDisplayInterval: NodeJS.Timeout = null;
    private raiseDuressEventDisplayNumber: number = 5;

	private async mounted() {
        await this.loadAllPrefs();

        // Check for the Pref Type 321 - 'Duress Modal Timeout Duration' 
        if (this.getPref !== undefined) {
            const prefTimeOutPeriod: Pref = this.getPref({ prefTypeID: PrefTypesEnum.DuressModalTimeoutDuration, groupID: -1 } as PrefTypeRequest);
            if (prefTimeOutPeriod !== undefined && prefTimeOutPeriod !== null) {
                this.modalTimeoutPeriodInSeconds = Number(prefTimeOutPeriod.value);
                this.raiseDuressEventTime = this.modalTimeoutPeriodInSeconds * 1000;         
            }
        }

        this.dataLoaded = true;
	}

    private get buttonDisabled(): boolean {
        if (this.dataLoaded === false) {
            return true;
        }

        return false;
    }

    private async openDuressModal() {
   
        // Raise the duress event automatically after the time out period
        clearTimeout(this.raiseDuressEventTimeOut);
        this.raiseDuressEventTimeOut = setTimeout(async () => {	
            if (this.showDuressModal === true) {
                this.raiseDuressEvent();
            }
            
            clearTimeout(this.raiseDuressEventTimeOut);
        }, this.raiseDuressEventTime);	
        
        // Updated the modal message based on the remaining time until the time out
        this.raiseDuressEventDisplayNumber = this.modalTimeoutPeriodInSeconds;
        clearInterval(this.raiseDuressEventDisplayInterval);
        this.raiseDuressEventDisplayInterval = setInterval(async () => {	       
            if (this.showDuressModal === false) {                                  
                clearInterval(this.raiseDuressEventDisplayInterval );
            }
            else {
                this.raiseDuressEventDisplayNumber -= 1;
                if (this.raiseDuressEventDisplayNumber < 0) {
                    this.raiseDuressEventDisplayNumber = 0;
                }
            }

            this.duressModalMessage = this.raiseDuressEventDisplayNumber.toString();
        }, this.raiseDuressEventDisplayTime);

        this.showDuressModal = true;
        this.duressModalMessage = this.raiseDuressEventDisplayNumber.toString();
    }

    private closeDuressModal() {         
        this.showDuressModal = false;
        this.duressModalMessage = "";
    }

    private async openErrorModal(errorMessage: string) {
        this.showErrorModal = true;
        this.errorModalMessage = errorMessage;
    }

    private closeErrorModal() {         
        this.showErrorModal = false;
        this.errorModalMessage = "";
    }

    private async raiseDuressEvent() {
        this.closeDuressModal();

        const raiseDuressEvent: RaiseDuressEvent = { latitude: 0, longitude: 0};
        if (this.deviceLocation !== undefined) {
            raiseDuressEvent.latitude = this.deviceLocation.lat();
            raiseDuressEvent.longitude = this.deviceLocation.lng();
        }
   
        let raiseDuressEventResponse: AxiosResponse<RaiseDuressEventResponse> = await api.raiseDuressEvent(raiseDuressEvent);

        if (raiseDuressEventResponse.status === this.raiseEventSuccessfulStatusNumber) {
            if (raiseDuressEventResponse.data !== undefined && raiseDuressEventResponse.data !== null) {
                if (raiseDuressEventResponse.data.successful === false) {
                    this.openErrorModal(raiseDuressEventResponse.data.error);
                }                
            }  
        } else {
            this.openErrorModal("Web error status code: " + raiseDuressEventResponse.status);
        }
    }
}
